var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContextData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e8e98;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.04 11.67 11.39 29.31 16.58 29.26 20.5 25.34 24.46 29.3 28.84 29.3 28.84 28.38 23.15 22.69 28.87 16.97 29.04 11.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,27V7c0-1.38,1.12-2.5,2.5-2.5,.57,0,1.08,.18,1.5,.5V25c-.42-.32-.93-.5-1.5-.5-1.38,0-2.5,1.12-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.5,30H5.5c-1.65,0-3-1.35-3-3V7c0-1.65,1.35-3,3-3,.66,0,1.28,.21,1.8,.6l.2,.15V26.01l-.8-.61c-.34-.26-.76-.4-1.2-.4-1.1,0-2,.9-2,2s.9,2,2,2H28.5V10h-2.83v-1h3.83V30ZM5.5,5c-1.1,0-2,.9-2,2V24.77c.77-.69,1.98-.96,3-.6V5.27c-.3-.17-.64-.27-1-.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.49 28.73 22.44 22.69 28.51 16.62 29.22 17.33 23.86 22.69 29.19 28.02 28.49 28.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.11 29.66 20.5 26.05 16.94 29.61 16.23 28.9 20.5 24.63 24.82 28.95 24.11 29.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.74,
    y: 19.99,
    width: 24.96,
    height: 1,
    transform: "translate(-8.57 20.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7,
    y: 9.22,
    width: 3.42,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,17.8l-4.37-4.37c-1.17-1.17-1.81-2.72-1.81-4.37s.64-3.2,1.81-4.37c1.17-1.17,2.72-1.81,4.37-1.81s3.2,.64,4.37,1.81h0c1.17,1.17,1.81,2.72,1.81,4.37s-.64,3.2-1.81,4.37l-4.37,4.37Zm0-13.93c-1.38,0-2.69,.54-3.67,1.52s-1.52,2.28-1.52,3.67,.54,2.69,1.52,3.67l3.67,3.67,3.67-3.67c.98-.98,1.52-2.28,1.52-3.67s-.54-2.69-1.52-3.67h0c-.98-.98-2.28-1.52-3.67-1.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 8.39,
    width: 1,
    height: 2.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.5,
    y: 6.39,
    width: 1,
    height: 4.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.5,
    y: 7.39,
    width: 1,
    height: 3.24
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextData);
export default __webpack_public_path__ + "static/media/ContextData.cfa4807a76d39c1165aaefeb5e052eb7.svg";
export { ForwardRef as ReactComponent };